import DomFactory from '../../common/factory/factory';

export default class AlternativeDomFactory extends DomFactory {
  public createWrapper() {
    const alternativeItem = document.createElement('div');
    alternativeItem.classList.add('alternative-item');
    return alternativeItem;
  }

  public createAlternativeLetter(letter: string) {
    const alternativeLetter = document.createElement('span');
    alternativeLetter.textContent = letter;
    alternativeLetter.classList.add('alternative-letter');
    return alternativeLetter;
  }

  public createAlternativeText(answer: string) {
    const alternativeText = document.createElement('span');
    alternativeText.textContent = answer;
    alternativeText.classList.add('alternative-text');
    return alternativeText;
  }

  public createAlternativeRadio() {
    const alternativeRadio = document.createElement('input');
    alternativeRadio.type = 'radio';
    alternativeRadio.name = 'alternative';
    alternativeRadio.classList.add('alternative-radio');
    return alternativeRadio;
  }
}
